import { ErrorState } from '@/components'
import React from 'react'
import { useSustainabilityApi } from '@/hooks/useApi/useSustainabilityApi/useSustainabilityApi'
import { ContentPlaceholder } from '@/components/molecules'
import { useTranslation } from 'react-i18next'
import { SustainabilityFiltersValues } from '@/utils/constants'
import { GHGEmissionsReportSettings } from '@/hooks'
import { GHGEmissionsTableContainer } from './GHGEmissionsTable/GHGEmissionsTableContainer'
import { useGHGEmissionsFiltersGetParams } from '../../hooks/useGHGEmissionsFiltersGetParams'

type GHGEmissionsViewProps = {
    reportSettings: GHGEmissionsReportSettings
    filters: SustainabilityFiltersValues
}

export const GHGEmissionsView: React.FC<GHGEmissionsViewProps> = ({
    reportSettings,
    filters,
}) => {
    const { t } = useTranslation('translations')

    const { useGHGEmissionsQuery } = useSustainabilityApi()
    const getParams = useGHGEmissionsFiltersGetParams(filters, reportSettings)

    const { data, isError, isLoading, isFetching, isFetched } =
        useGHGEmissionsQuery(getParams)
    const hasData = Array.isArray(data?.items) && data.items.length > 0

    const emptyStateDescription = t(
        'analytics.common.report_empty_state.description'
    )

    if (isError) {
        return <ErrorState description={t('analytics.common.report_error')} />
    }

    if (isFetched && !hasData) {
        return (
            <ContentPlaceholder
                title={t('analytics.common.report_empty_state.title')}
                description={emptyStateDescription}
                illustrationSrc="/assets/empty-state-illustration.svg"
                name="empty-state"
            />
        )
    }

    return (
        <div className="relative" data-testid="ghg-emissions-view">
            <div className="min-h-widgetHeight">
                <GHGEmissionsTableContainer
                    data={data?.items ?? []}
                    isLoading={isLoading || isFetching || !isFetched}
                    startDate={getParams.startDate}
                    endDate={getParams.endDate}
                    reportSettings={reportSettings}
                />
            </div>
        </div>
    )
}
